import {configOptions} from "@/lib/handlers/sentry.tsx";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import {register} from "register-service-worker";
import App from "./App.tsx";

register("/google-analytics-workaround-service-worker.js");

Sentry.init(configOptions);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
